import React, { useEffect, useState } from "react";
import type { FormProps } from 'antd';
import { Link } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import { Button, Divider, Checkbox, Form, Input, Select, InputNumber ,message} from 'antd';
type FieldType = {
    title?: string;
    product_number?: string | number;
    category?: string;
    price?:string | number
};

const onFinish: FormProps<FieldType>['onFinish'] = (values) => {
    FetchWithAuth('/api/content/create/product',{
        method: "POST",
        body: JSON.stringify(values),
      }).then(res => {
        if(!res.error){
            message.success({
                content:'提交成功'
            });
        }else{
            message.error({
                content:res.data.message
            })
        }
    })
};

const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
};

const CreateProduct: React.FC = () => {

    return (
        <div>
            <div className="header-container">
                <h2>创建产品</h2>
            </div>
            <div>
                <Form
                    name="basic"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    style={{ maxWidth: 600 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <Form.Item<FieldType>
                        label="名称"
                        name="title"
                        rules={[{ required: true, message: '请输入产品名称' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item<FieldType>
                        label="产品号"
                        name="product_number"
                        rules={[{ required: true, message: '请输入产品号' }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item<FieldType>
                        label="分类"
                        name="category"
                        rules={[{ required: true, message: '请选择分类' }]}
                    >
                        <Select>
                            <Select.Option value="a">A</Select.Option>
                            <Select.Option value="b">B</Select.Option>
                            <Select.Option value="c">C</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item<FieldType>
                        label="价格"
                        name="price"
                        rules={[{ required: true, message: '请输入价格' }]}
                    >
                        <InputNumber min={1} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                            提交
                        </Button>
                        <Link to={"/product/list"}>
                            {" "}
                            <Button style={{ marginLeft: '12px' }}>
                            返回
                        </Button>
                        </Link>
                        
                    </Form.Item>
                </Form>
            </div>
        </div>
    )

}

export default CreateProduct